class BoxSelectionQuantityInput extends HTMLElement {
  static observedAttributes = ['max', 'total'];

  max = 0;
  total = 0;

  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.errorEvent = new Event('error', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  attributeChangedCallback(name, _, newValue) {
    if (name === 'max') {
      this.input.setAttribute('max', newValue);
      this.max = parseInt(newValue);
      if (this.total > newValue) this.input.value = 0;

      if (this.total === this.max) this.input.disabled = true;
      else this.input.disabled = false;
    }

    if (name === 'total') {
      this.total = parseInt(newValue);

      if (newValue === this.max) this.input.disabled = true;
      else this.input.disabled = false;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const maxNumberValue = parseInt(this.input.getAttribute('max')) || null;
    const parentElem = this.input.parentElement;

    const plusButton = parentElem.querySelector('.qtyplus');
    const inputNumberValue = parseInt(this.input.value);

    if (!maxNumberValue || inputNumberValue < maxNumberValue) {
      event.currentTarget.name === 'plus' ? this.increment() : this.decrement();
    } else if (
      inputNumberValue === maxNumberValue &&
      event.currentTarget.name === 'minus'
    ) {
      this.decrement();
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  increment() {
    if (parseInt(this.total) + 1 > this.max) {
      return;
    }

    this.input.stepUp();
  }

  decrement() {
    this.input.stepDown();
  }
}

if (!customElements.get('box-selection-quantity-input')) {
  customElements.define(
    'box-selection-quantity-input',
    BoxSelectionQuantityInput
  );
}
